<template>
  <div>
    <div class="bs-example-modal multi-image-select">
      <div
        class="instruction_title text-left para-mrgn-20"
        v-translate:dynamic_string="{
          key: `${translationKeyInitial}_formattedBody`,
          val: lang,
          html: question.formattedBody
        }"
        v-html="question.formattedBody"
      />
      <div class="modal-body select-scroll img-content">
        <b-form-group class="mb-5" v-if="componentData.subType === 'Single'">
          <b-form-radio-group v-model="question.optionsIds[0]" stacked :disabled="isFieldDisabled" v-on:change="onAnswerChange($event)" @click.once="$emit('onClick', question)">
            <b-form-radio v-for="(option, optionIndex) in languageImageOptions.options" :key="optionIndex" :value="option.id">
              <img v-if="option.id != componentData.otherOptionId" class="imageBox pl-0 text-center img-size img-fluid pt-3" :src="option.imageUrl" />
              <span v-else>{{ option.imageUrl }}</span>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group v-if="componentData.subType === 'Multi'">
          <b-form-checkbox-group @click.once="$emit('onClick', question)" v-model="question.optionsIds" stacked :disabled="isFieldDisabled" v-on:change="onAnswerChange($event)">
            <b-form-checkbox v-for="(option, optionIndex) in languageImageOptions.options" :key="optionIndex" :value="option.id">
              <img v-if="option.id != componentData.otherOptionId" class="imageBox pl-0 text-center img-size" :src="option.imageUrl" />
              <span v-else>{{ option.imageUrl }}</span>
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
        <span class="text-danger pl-5 fw-bold pt-10" v-if="hasFieldError">{{ fieldErrorText }}</span>

        <div>
          <div v-if="componentData.isDisplayOtherOptionContentField">
            <span maxlength="10">{{ componentData.otherOptionContentField }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import localStorageService from "@/services/localStorage";
import langTranslate from "./lang-translate";
export default {
  name: "image-choice",
  mixins: [langTranslate],
  data() {
    return {
      hasFieldError: ""
    };
  },
  mounted() {
    this.insertOtherOption();
    this.$root.$on("questionSkipped", (notifyObj) => {
      if(!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped){
        this.clearAnswer();
      }
    });
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  computed: {
    componentData() {
      return this.updatedComponentData();
    },
    globalElement() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    languageImageOptions() {
      const defaultLanguageId = localStorageService.getItem("default-languageId");
      let languageImageOptions;
      if (this.componentData.languageImageOptions) {
        languageImageOptions = this.componentData.languageImageOptions.find(o => o.languageCulture.toLowerCase() === "en");
        if (languageImageOptions) {
          return languageImageOptions;
        }
        languageImageOptions = this.componentData.languageImageOptions.find(o => o.languageId === defaultLanguageId);
      } else {
        languageImageOptions = this.componentData;
      }
      return languageImageOptions;
    }
  },
  methods: {
    updatedComponentData() {
      const componentData = this.question.constraints;
      this.question.optionsIds = this.question.optionsIds ? this.question.optionsIds : [];
      if (componentData.subType == "Single") {
        this.question.optionsIds[0] = null;
      }
      return componentData;
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.$emit("onAnswerChange", this.question);
      });
    },
    getImageURL(optionId, languageImageOptions) {
      if (languageImageOptions && languageImageOptions[0] && languageImageOptions[0].options) {
        let imageURL = null;
        languageImageOptions[0].options.forEach(languageImageOption => {
          if (languageImageOption.id === optionId) {
            imageURL = languageImageOption.imageUrl;
            return;
          }
        });
        return imageURL;
      }
    },
    insertOtherOption() {
      if (this.componentData.otherOptionId) {
        const sequence = this.componentData.languageImageOptions[0].options.length + 1;
        this.componentData.languageImageOptions[0].options.push({
          enabled: true,
          excludeScore: false,
          formattedBody: "",
          id: this.componentData.otherOptionId,
          imageId: this.componentData.otherOptionId,
          imageUrl: this.componentData.otherOptionContentField,
          isAdvancedScoring: false,
          previewImageUrl: this.componentData.otherOptionContentField,
          priority: 0,
          score: 0,
          sendNotification: false,
          sequence: sequence
        });
      }
    },
    clearAnswer(){
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.question.answer = undefined;
      this.question.optionsIds = [];
    }
  }
};
</script>

<style scoped>
.modal-header {
  margin-left: auto;
  margin-right: auto;
}
.img-content {
  height: auto;
  min-height: 200px;
}
</style>
